<template>
  <div id="modalSupplierKpiDetail" class="modal fade">
    <div
      class="modal-dialog modal-dialog-vertical-center modal-lg"
      role="document"
    >
      <div class="modal-content bd-0 tx-14">
        <div class="modal-header pd-y-20 pd-x-25">
          <h6 class="tx-14 mg-b-0 tx-uppercase tx-inverse tx-bold">
            {{ $t("financial.详情") }}
          </h6>
          <button
            type="button"
            data-dismiss="modal"
            aria-label="Close"
            class="close"
          >
            <span aria-hidden="true">×</span>
          </button>
        </div>
        <div class="modal-body pd-25">
          <div
            class="form-group row"
            v-for="(val, name) in item.content"
            :key="name"
          >
            <div class="col-6">
              <span style="padding-left: 30px">{{ name }}：</span>
            </div>
            <div class="col-6">{{ val }}</div>
          </div>
        </div>
        <div class="modal-footer">
          <button
            class="btn btn-primary"
            data-dismiss="modal"
            aria-label="Close"
          >
            {{ $t("financial.关闭") }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["open", "item"],
};
</script>
